import React from 'react'

import * as Yup from 'yup'
import { Form, Input } from 'formik-antd'
import { BasicForm, Editor } from '../../../../core/components/form'
import { usePutForm, useFetch } from '../../../../hooks/admin/template'
import { useHistory, useParams } from 'react-router-dom'
import Loader from '../../../../components/loader'
import { isNotValid, translateSymfonyErrorToFormik } from '../../../../core/utils/form'

const ValidationSchema = Yup.object().shape({
  subject: Yup.string().required('Name cannot be blank.'),
  body: Yup.string().required('Name cannot be blank.')
})

const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 16 }
}

const Formulario = () => {
  const { id } = useParams()
  const { data, isLoading, isError } = useFetch(id)
  const update = usePutForm(id)
  const history = useHistory()

  function handleSubmit (values, bag) {
    const form = { ...values }

    update.mutate(form, {
      onSuccess: (data) => {
        bag.setSubmitting(false)
        onPressBack()
      },
      onError: (error, variables, context) => {
        bag.setSubmitting(false)
        if (error.response.status === 400) {
          const data = error.response?.data
          if (isNotValid(data)) {
            bag.setErrors(translateSymfonyErrorToFormik(data?.errors?.children))
          }
        }
      }
    })
  }

  const onPressBack = () => history.goBack()

  if (isLoading) {
    return (<Loader loading={isLoading} />)
  }

  if (isError) {
    return (<>Error</>)
  }

  const initialValues = {
    subject: data.entidad.subject,
    body: data.entidad.body
  }

  return (
    <BasicForm
      onPressBack={onPressBack}
      titulo='TEMPLATE'
      initialValues={initialValues}
      validationSchema={ValidationSchema}
      onSubmit={handleSubmit}
      render={({ touched, errors }) => (
        <>
          <Form.Item name='subject' label='Subject' required>
            <Input name='subject' />
          </Form.Item>
          <Editor
            name='body'
            label='Body'
            placeholder='Body'
            errors={errors.body}
            touched={touched.body}
            layout='horizontal'
            formItemLayout={formItemLayout}
            required
          />
        </>
      )}
    />
  )
}

export default Formulario
